import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createAppRouter } from '@/app/router'
// Side effect: subscribes the UI language to the account preference (T4.7).
import '@/lib/i18n/store'
// Side effect: keeps <html data-theme> in step with the preference and the OS.
import '@/lib/theme'
import '@/styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root not found')

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={createAppRouter()} />
  </StrictMode>,
)
